// "* Required information" footnote shown under every form in the join
// journey, per the CareSuper reference screenshots.
function RequiredFooter() {
  return (
    <p className="text-xs mt-4" style={{ color: "#6B7280" }}>
      <span style={{ color: "#DC2626" }}>*</span> Required information
    </p>
  );
}

export default RequiredFooter;
